<template>
  <div class="tbox-container">
    <div class="content" ref="table">
      <div class="tools clearfix">
        <div class="left">
          <el-select
            v-model="form.type"
            placeholder="请选择排序方式"
            style="width: 160px; display: inline-block"
          >
            <el-option
              v-for="item in options"
              :key="item.sort"
              :label="item.name"
              :value="item.sort"
            >
            </el-option>
          </el-select>
          <el-input
            v-model="form.value"
            placeholder="请输入TBOX编号或车架号"
            style="width: 210px; display: inline-block; margin-left: 10px"
            clearable
          ></el-input>
          <el-button type="primary" style="margin-left: 16px" @click="Getdata"
            >搜索</el-button
          >
        </div>
        <div class="right">
          <el-button
            type="primary"
            style="margin-left: 16px"
            icon="el-icon-plus"
            @click="$router.push('/tbox/add')"
            v-hasPermi="['TBOX管理', '新增']"
            >新增数据</el-button
          >
        </div>
      </div>
      <el-table
        stripe
        :data="table.data"
        v-loading="loading"
        :height="table.height"
        :header-cell-style="{ background: '#eaeef6' }"
        ref="tables"
        :fit="true"
      >
        <el-table-column type="index" label="序号" align="center">
        </el-table-column>
        <el-table-column
          prop="tbox_num"
          label="TBOX编号"
          show-overflow-tooltip
          width="260"
          align="center"
        >
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <span class="status green" v-show="scope.row.status == 1"
              >在线</span
            >
            <span class="status" v-show="scope.row.status == 0">离线</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="frame_num"
          label="车架号"
          width="180"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="brand"
          label="车辆品牌"
          align="center">
        </el-table-column>
        <el-table-column
          prop="type"
          label="车辆型号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="model"
          label="车型"
          align="center">
        </el-table-column> -->
        <el-table-column
          prop="iccid"
          label="ICCID"
          width="200"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="validTime"
          label="有效期"
          width="150"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">{{
            scope.row.validTime | dateYMDHMSFormat
          }}</template>
        </el-table-column>
        <el-table-column
          prop="software_version"
          label="软件版本编号"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="belongCompanyName"
          label="所属公司"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          min-width="100"
          align="center"
          fixed="right"
        >
          <template slot-scope="scope">
            <div class="edit">
              <span
                class="btn read"
                @click="readClick(scope.row.id)"
                v-hasPermi="['TBOX管理', '详情']"
                >查看</span
              >
              <span
                class="btn read"
                v-show="!scope.row.frame_num"
                @click="del(scope.row.id)"
                v-hasPermi="['TBOX管理', '删除']"
                >删除</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="sizes,prev, pager, next"
          :current-page.sync="table.currentPage"
          :page-size="table.size"
          :total="table.total"
          @current-change="currentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { GetTboxdata, GetSortList, delData } from '@/api/tbox'
import { MessageBox } from 'element-ui'
export default {
  data () {
    return {
      form: {
        value: '',
        type: ''
      },
      loading: false,
      options: [{ name: '默认', sort: '' }],
      table: {
        data: [],
        height: 100,
        currentPage: 1,
        size: 50,
        total: 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.table.height = window.innerHeight - this.$refs.table.offsetTop - 170
      window.onresize = () => {
        this.table.height = window.innerHeight - this.$refs.table.offsetTop - 170
      }
    })
    this.Getdata()
    this.getSortData()
  },
  methods: {
    //删除
    del (id) {
      MessageBox.confirm('是否删除该信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delData({ id }).then(res => {
          if (res.code === 0) {
            this.$message.success(res.message);
            this.Getdata()
          } else {
            this.$message.error(res.message);
          }
        })
      }).catch(() => {
        this.$message('已取消注销')
      });
    },
    getSortData () {
      GetSortList()
        .then(res => {
          this.options = this.options.concat(res.data)
        })
    },
    Getdata () {
      this.loading = true
      const params = { start: this.table.currentPage, size: this.table.size, name: this.form.value, tbox_num: this.form.value }
      this.form.type ? params.sort = this.form.type : ''
      GetTboxdata(params).then(res => {
        this.loading = false
        const data = res.data
        this.table.data = data.content
        this.table.total = data.total
        this.$refs.tables.bodyWrapper.scrollTop = 0;
      }
      )
    },
    currentChange () {
      this.Getdata()
    },
    handleSizeChange (e) {
      this.table.currentPage = 1
      this.table.size = e
      this.Getdata()
    },
    readClick (id) {
      this.$router.push({ name: 'edit', query: { id } })
    }
  },
  filters: {
    status_f (val) {
      let res = ''
      switch (val) {
        case 0:
          res = '离线'
          break;
        case 1:
          res = '在线'
          break;
      }
      return res
    }
  }
}
</script>

<style lang="less" scoped>
.tbox-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .content {
    flex: 1;
    min-height: 0;
    background: #fff;
    padding: 20px;
    box-shadow: 0 0 6px 1px #acacac;
    .tools {
      padding-bottom: 20px;
      .left {
        float: left;
        input {
        }
      }
      .right {
        float: right;
      }
    }
    .edit {
      .btn {
        color: #3992de;
        cursor: pointer;
        & + .btn {
          margin-left: 24px;
        }
      }
    }
    .status {
      &.green {
        color: #53c553;
      }
    }
    .pagination {
      text-align: center;
      padding-top: 20px;
    }
  }
}
</style>
<style lang="less">
.tbox-container {
  .el-table {
    .gutter {
      background: #eaeef6;
    }
  }
}
</style>
